import React, { useRef } from "react";
import { Form, Button, Message } from "semantic-ui-react";
import { useForm } from "react-hook-form";
import { useCustomerEstimateContext } from "./CustomerEstimateContext";

export interface IFieldTypes {
  address: string;
}

const CustomerCalculatorForm: React.FC<any> = () => {
  const { onSubmit } = useCustomerEstimateContext();
  const inputRef = useRef<HTMLInputElement | null>(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<IFieldTypes>();

  const { ref: addressFieldRef, ...addressField } = register("address", {
    required: true,
  });

  const [hasServerError, setServerError] = React.useState<boolean>(false);

  // Initialize Google Places Autocomplete
  React.useEffect(() => {
    const google = (window as any).google;
    if (!inputRef.current || !google?.maps?.places) return;

    const autocomplete = new google.maps.places.Autocomplete(
      inputRef.current,
      {
        types: ["address"],
        componentRestrictions: { country: "us" },
      }
    );

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (place.formatted_address) {
        setValue("address", place.formatted_address);
      }
    });
  }, [setValue]);

  const handleFormSubmit = async (data: IFieldTypes) => {
    try {
      setServerError(false);
      await onSubmit(data);
    } catch (err) {
      setServerError(true);
    }
  };

  return (
    <Form onSubmit={handleSubmit(handleFormSubmit)} error={hasServerError}>
      <Form.Field>
        <label>Address</label>
        <input
          {...addressField}
          ref={(el) => {
            addressFieldRef(el);
            inputRef.current = el;
          }}
          placeholder="Start typing your address..."
          style={{
            width: "100%",
            padding: "0.67857143em 1em",
            border: "1px solid rgba(34,36,38,.15)",
            borderRadius: "0.28571429rem",
            fontSize: "1em",
          }}
        />
        {errors.address && (
          <span style={{ color: "red", fontSize: "0.85rem" }}>
            Please enter your address
          </span>
        )}
      </Form.Field>

      <p style={{ color: "#666", fontSize: "0.9rem", marginBottom: "1rem" }}>
        Please include your full address with city and state.
      </p>

      <Button type="submit">Get Estimate</Button>

      <Message
        error
        header="Invalid Address"
        content="Please enter a valid address and try again."
      />
    </Form>
  );
};

export default CustomerCalculatorForm;
